import { Bugsnag } from '@bolteu/bugsnag-service-react-web';
import { ModuleSetup } from '@bolteu/lattice';

import { ApiClient } from '../api';
import { ConfigType } from '../config';
import { AccountService } from './AccountService';
import { EventAliasingService } from './EventAliasingService';
import { MixpanelService } from './MixpanelService';
import { NotificationService } from './NotificationService';
import { SessionService } from './SessionService';
import { TargetingService } from './TargetingService';
import { TrackingService } from './TrackingService';

export enum Environment {
  LOCAL,
  TEST,
  PRELIVE,
  LIVE,
}

export class CommonApplicationServices {
  public constructor(
    public accountService: AccountService,
    public apiClient: ApiClient,
    public bugsnag: Bugsnag.Service,
    public mixpanelService: MixpanelService,
    public trackingService: TrackingService,
    public eventAliasingService: EventAliasingService,
    public notificationService: NotificationService,
    public targetingService: TargetingService,
    public sessionService: SessionService,
    public config: ConfigType,
    private module?: ModuleSetup,
  ) {}

  public createForModule(module: ModuleSetup): CommonApplicationServices {
    return new CommonApplicationServices(
      this.accountService,
      this.apiClient,
      this.bugsnag,
      this.mixpanelService,
      this.trackingService,
      this.eventAliasingService,
      this.notificationService,
      this.targetingService,
      this.sessionService,
      this.config,
      module,
    );
  }

  public get moduleName() {
    if (!this.module) {
      throw new Error('Cannot query moduleName within global application context');
    }

    return this.module.config?.moduleName;
  }
}
